'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'laptop';
var width = 640;
var height = 512;
var aliases = [128187];
var unicode = 'f109';
var svgPathData = 'M560 48L80 48l0 304-16 0L64 48l0-16 16 0 480 0 16 0 0 16 0 304-16 0 0-304zM54.6 464l530.7 0L624 425.4l0-25.4L16 400l0 25.4L54.6 464zM640 384l0 16 0 32-48 48L48 480 0 432l0-32 0-16 16 0 608 0 16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLaptop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;